import React from "react";
import { useSelector } from "react-redux";

const AnswerList = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const data = `${ answeringQuestions.data.qstCransr || '' };${ answeringQuestions.data.cransrTyScnCdNm || '' }`;

  const OPTIONS = data.split( ';' ).map( ( v, i ) => <option key={ i } value={ i }>{ v }</option> );

  return (
    <div className="inspection-select-wrap answer">
      <select value={ answeringQuestions.answerIndex } onChange={ props.onChange }>{ OPTIONS }</select>
    </div>
  );

};

export default AnswerList;
